module.exports = __webpack_public_path__ + "static/media/methodology_summer.ad2b8488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/methodology_summer.jpg
// module id = 865
// module chunks = 0